import { Link, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { AlertCircle, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useIncompleteProfile } from "@/hooks/useIncompleteProfile";
import { useLanguage } from "@/i18n/LanguageContext";

export default function IncompleteProfileBanner() {
  const incomplete = useIncompleteProfile();
  const { pathname } = useLocation();
  const { t } = useLanguage();

  const visible = incomplete && pathname !== "/complete-profile";

  return (
    <AnimatePresence>
      {visible && (
        <>
          {/* Spacer to push content below the fixed banner */}
          <div className="h-12 sm:h-10" />
          <motion.div
            initial={{ y: -60, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: -60, opacity: 0 }}
            transition={{ type: "spring", stiffness: 300, damping: 30 }}
            className="fixed top-0 left-0 right-0 z-[90] border-b border-amber-500/30 bg-amber-500/10 backdrop-blur-sm"
          >
            <div className="mx-auto flex items-center justify-center gap-3 px-4 py-2.5 text-sm">
              <AlertCircle className="h-4 w-4 shrink-0 text-amber-400" />
              <span className="text-amber-200">
                {t.waitlist?.incompleteProfileBanner}
              </span>
              <Button
                asChild
                size="sm"
                variant="outline"
                className="ml-1 h-7 border-amber-500/40 bg-amber-500/10 px-3 text-xs text-amber-200 hover:bg-amber-500/20 hover:text-amber-100"
              >
                <Link to="/complete-profile">
                  {t.waitlist?.incompleteProfileCta}
                  <ArrowRight className="ml-1 h-3 w-3" />
                </Link>
              </Button>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}
